export default {
  /* 文案说明 */
  income_center_title: "结算记录",

  /* 表格字段 */
  t_settlement_month: "结算月份",
  t_month_new_sign_settlement_commission: "当月新签结算佣金(元)",
  t_history_new_sign_commission_rest: "历史新签佣金尾款(元)",
  t_month_deduction_amount: "本月扣减金额(元)",
  t_month_actual_settlement_amount: "本月实际结算金额(元)",
  t_settlement_status: "结算状态",
  t_operation: "操作",
  t_confirm_btn_text: "确认结果",
  t_re_review_btn_text: "重新复核",

  t_settlement_status_00: "作废",
  t_settlement_status_0: "待审核",
  t_settlement_status_1: "商务已确认",
  t_settlement_status_2: "合作商已确认",
  t_settlement_status_3: "完成结算",
  t_settlement_status_4: "重新核算",
}
